export enum TagType {
    LocalType,    // Kafić, Restoran, Picerija
    Feature,      // Bašta, Pet friendly, Parking
    Ambience,      // Za rad, Porodično, Romantično
    FoodCategory, // Burgeri, Pizza, Doručak
}

export function tagTypeToString(tagType: TagType): string {
    switch (tagType) {
        case TagType.LocalType:
            return 'Tip lokala';
        case TagType.Feature:
            return 'Feature';
        case TagType.Ambience:
            return 'Ambijent';
        case TagType.FoodCategory:
            return 'Kategorija hrane';
        default:
            return 'Nepoznat tip';
    }
}

export function tagTypeToSmallBoxClass(tagType: TagType): string {
    switch (tagType) {
        case TagType.LocalType:
            return 'light-skyblue-bg';
        case TagType.Feature:
            return 'light-green-bg';
        case TagType.Ambience:
            return 'light-purple-bg';
            //TO DO - izabrati neku boju za food category
        case TagType.FoodCategory:
            return 'light-orange-bg';   
        default:
            return '';
    }
}